import React from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const testimonialsData = [
  {
    text: "Uma experiência incrível! A vista é de tirar o fôlego. Voltaremos com certeza!",
    author: "Maria S.",
    location: "São Paulo, SP"
  },
  {
    text: "Lugar perfeito para um casal. Romântico, privado e com tudo que precisávamos.",
    author: "João P.",
    location: "Rio de Janeiro, RJ"
  },
  {
    text: "A cabana é impecável, cada detalhe pensado com carinho. A jacuzzi é maravilhosa.",
    author: "Ana C.",
    location: "Belo Horizonte, MG"
  }
];

const Testimonials = () => {
  const scrollToBooking = () => {
    const bookingSection = document.querySelector('.booking-widget');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <h2>O que nossos hóspedes dizem</h2>
      <div className="reviews-container">
        {testimonialsData.map((review, index) => (
          <div className="review glass-panel" key={index}>
            <div className="review-header">
              <FaQuoteLeft className="quote-icon" />
              <div className="stars">
                {[...Array(5)].map((_, i) => <FaStar key={i} />)}
              </div>
            </div>
            <p>"{review.text}"</p>
            <div className="review-author">
              <strong>{review.author}</strong>
              <span>{review.location}</span>
            </div>
          </div>
        ))}
      </div>
      
      <div className="testimonials-cta-container">
        <button className="section-cta" onClick={scrollToBooking}>
          Reservar
        </button>
      </div>
    </section>
  );
};

export default Testimonials;
